import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { API, api, fmtQty } from "../api";
import { Printer, ArrowLeft } from "lucide-react";

export default function LotLabel() {
  const { id } = useParams();
  const [lot, setLot] = useState(null);

  useEffect(() => { api.get(`/lots/${id}`).then((r) => setLot(r.data)).catch(() => {}); }, [id]);

  if (!lot) return <div className="text-slate-500 p-8">Loading...</div>;

  return (
    <div data-testid="lot-label-page" className="space-y-6">
      <div className="flex gap-3 no-print">
        <Link to={`/lots/${id}`} className="h-10 px-4 rounded-md border border-border inline-flex items-center gap-2 text-sm font-semibold text-[#002B5D]">
          <ArrowLeft className="w-4 h-4" /> Back to Lot
        </Link>
        <button data-testid="print-label-button" onClick={() => window.print()}
          className="h-10 px-5 rounded-md font-heading font-bold text-sm text-white inline-flex items-center gap-2" style={{ backgroundColor: "#EB1C27" }}>
          <Printer className="w-4 h-4" /> Print Label
        </button>
      </div>

      <div id="print-area" className="bg-white border-2 border-[#002B5D] rounded-md p-6 max-w-sm mx-auto" data-testid="qr-label">
        <div className="flex items-center justify-between border-b-2 pb-3" style={{ borderColor: "#EB1C27" }}>
          <div className="font-heading font-extrabold text-xl text-[#002B5D] tracking-tight">SK ZIPPERS</div>
          <div className="w-8 h-8 grid place-items-center font-heading font-extrabold text-white text-sm rounded-sm" style={{ backgroundColor: "#EB1C27" }}>SK</div>
        </div>
        <div className="flex justify-center py-5">
          <img src={`${API}/lots/${id}/qr`} alt="QR" className="w-48 h-48" data-testid="label-qr-image" />
        </div>
        <div className="text-center">
          <div className="font-mono font-bold text-2xl text-[#002B5D]" data-testid="label-lot-number">{lot.lot_number}</div>
          <div className="font-heading font-semibold text-slate-700 mt-1">{lot.product_name}</div>
          <div className="font-mono text-xs text-slate-500 mt-1">{fmtQty(lot.produced_qty)} {lot.uom}</div>
        </div>
      </div>
    </div>
  );
}
